import React from 'react'
import PropTypes from 'prop-types'

/**
 * Button to open the sidebar
 */
function SidebarOpenButton (props) {
  return (
    <button className='px-4 py-4 text-gray-500 focus:outline focus:outline-primary-500 focus:text-primary-500 xl:hidden' aria-label='Open sidebar' onClick={props.onClick}>
      <svg className='h-6 w-6' stroke='currentColor' fill='none' viewBox='0 0 24 24'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M4 6h16M4 12h16M4 18h7' />
      </svg>
    </button>
  )
}

export default SidebarOpenButton
